import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import {
  PERFORMANCE_STATUS_CONFIG,
  PERFORMANCE_STATUS_SNAKE_CASE_MAP,
} from './performanceMonitoring/constants';
import { PerformanceStatusOption } from './performanceMonitoring/types';

import { usePlatform } from '@/features/users';

interface PerformanceStatusFilterProps {
  performanceStatus: string | undefined;
  onPerformanceStatusChange: (performanceStatus: string | undefined) => void;
}

export const PerformanceStatusFilter = ({
  performanceStatus,
  onPerformanceStatusChange,
}: PerformanceStatusFilterProps) => {
  const platform = usePlatform();
  const isDV360 = platform === 'DV360';

  const options = Object.keys(
    PERFORMANCE_STATUS_CONFIG
  ) as PerformanceStatusOption[];

  const value = options.find(
    (opt) => PERFORMANCE_STATUS_SNAKE_CASE_MAP[opt] === performanceStatus
  );

  return (
    <Autocomplete
      size='small'
      options={options}
      value={value}
      onChange={(_e, newValue) => {
        onPerformanceStatusChange(newValue);
      }}
      sx={{ width: 400 }}
      disableClearable
      getOptionLabel={(option) =>
        PERFORMANCE_STATUS_CONFIG[option].dropdownLabel
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={isDV360 ? 'Insertion Order Status' : 'Campaign Status'}
          sx={{ minWidth: 220 }}
        />
      )}
    />
  );
};
